import { ButtonProps, CircularProgress, Stack, useTheme } from "@mui/material";
import { MouseEventHandler, useCallback, useMemo, useState } from "react";
import { XButton } from "./x-button";

export type ProgressButtonProps = ButtonProps & {
  hideProcessing?: boolean;
  asyncAction?: () => Promise<any>;
};
export const XProgressButton = (props: ProgressButtonProps) => {
  const [isProgressing, setIsProgressing] = useState<boolean>(false);
  const theme = useTheme();
  const btnProps = useMemo(() => {
    const { hideProcessing, asyncAction, ...btnProps } = props;
    return btnProps as ButtonProps;
  }, [props]);

  const onClickHandler: MouseEventHandler<HTMLButtonElement> = useCallback(
    async (e) => {
      try {
        setIsProgressing(true);
        await props.asyncAction?.();
        props.onClick?.(e);
      } catch (ex) {
        console.error("Have some error when execite async function", ex);
      } finally {
        setIsProgressing(false);
      }
    },
    [props]
  );
  return (
    <XButton
      {...btnProps}
      startIcon={
        <Stack direction={"row"} spacing={1} alignItems={"center"}>
          {!props.hideProcessing && isProgressing && (
            <CircularProgress size={theme.typography.fontSize} />
          )}
          {props.startIcon}
        </Stack>
      }
      onClick={onClickHandler}
      disabled={props.disabled || isProgressing}
    >
      {props.children}
    </XButton>
  );
};
